import { useEffect, useRef, useState } from 'react';

import { useDirectoryRefresher } from 'src/shared/hooks/shared.hook.useDirectoryRefresher';
import { useDirectoryChannels } from 'src/shared/hooks/useDirectory';

export function useWaitForChannels() {
  const [waitingForChannels, setChannels] = useState<string[]>([]);
  const resolveRef = useRef<((value: undefined) => void) | null>(null);
  const channels = useDirectoryChannels({
    excludeDeleted: true,
    requireQbInChannel: true,
  });

  useEffect(() => {
    if (!waitingForChannels.length) {
      return;
    }

    const foundChannels = channels.filter((c) =>
      waitingForChannels.includes(c.id),
    );

    console.log(
      `found ${foundChannels.length} of ${waitingForChannels.length} channels`,
    );

    if (foundChannels.length === waitingForChannels.length) {
      setChannels([]);
    }
  }, [waitingForChannels, channels]);

  const isWaiting = !!waitingForChannels.length;

  useDirectoryRefresher(
    {
      channels: true,
    },
    isWaiting,
    3000,
  );

  useEffect(() => {
    if (resolveRef.current && !isWaiting) {
      resolveRef.current(undefined);
      resolveRef.current = null;
    }
  }, [channels, isWaiting]);

  return async (channels: string[]) => {
    if (!channels.length) {
      return;
    }

    setChannels(channels);
    return new Promise(async (r) => {
      resolveRef.current = r;
      await new Promise((resolve) => setTimeout(resolve, 10000));
      resolveRef.current?.(undefined);
    });
  };
}
